module.exports = __webpack_public_path__ + "static/other/character_feedback.bea78e6b.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/fitFiveGame/character_feedback.json
// module id = 2376
// module chunks = 0